import { X } from 'lucide-react';
import './SideSheet.css';

function SideSheet({ isOpen, onClose, children, title }) {
  return (
    <>
      {/* Overlay */}
      <div 
        className={`side-sheet-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
      />
      
      {/* Side Sheet */}
      <div className={`side-sheet ${isOpen ? 'open' : ''}`}>
        <div className="side-sheet-header">
          <h2 className="side-sheet-title">{title}</h2>
          <button 
            className="side-sheet-close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="side-sheet-content">
          {children}
        </div>
      </div>
    </>
  );
}

export default SideSheet;

